// src/components/HolidayBanner.js
import React, { useState } from 'react';
import './HolidayBanner.css';

// ─────────────────────────────────────────────────────────────
// Bannière vacances — modifier ici pour les prochaines vacances
// SHOW_UNTIL : la bannière disparaît automatiquement à partir de cette date
// (jour de reprise des cours, 00:00 heure de Bruxelles).
// ─────────────────────────────────────────────────────────────
const BANNER_ID = 'holiday-toussaint-2026';
const SHOW_UNTIL = new Date('2026-11-04T00:00:00+01:00');
const MESSAGE = 'NO CLASSES FROM 28/10 TO 1/11 — STARTING AGAIN ON 4/11';

const storageKey = `mkd-banner-dismissed-${BANNER_ID}`;

const isDismissed = () => {
  try {
    return localStorage.getItem(storageKey) === '1';
  } catch {
    return false;
  }
};

export default function HolidayBanner() {
  const [hidden, setHidden] = useState(isDismissed);

  if (hidden || new Date() >= SHOW_UNTIL) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      /* stockage indisponible : on masque juste pour cette visite */
    }
    setHidden(true);
  };

  return (
    <div className="holiday-banner" role="status">
      <span className="holiday-banner-icon" aria-hidden="true">🎃</span>
      <p className="holiday-banner-text">{MESSAGE}</p>
      <button
        type="button"
        className="holiday-banner-close"
        onClick={dismiss}
        aria-label="Fermer"
      >
        ×
      </button>
    </div>
  );
}
